(() => {
  const body = document.body;
  const overlay = document.querySelector('[data-overlay]');
  const mobileMenu = document.querySelector('#MobileMenu');
  const menuButton = document.querySelector('.menu-button');
  const mobileClose = document.querySelector('.mobile-close');
  const cartDrawer = document.querySelector('#CartDrawer');
  const cartButton = document.querySelector('.bag-button');
  const cartClose = document.querySelector('.bag-close');
  const toast = document.querySelector('.toast');

  const escapeHTML = (value = '') => String(value).replace(/[&<>'"]/g, (character) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', "'": '&#39;', '"': '&quot;' })[character]);
  const formatMoney = (cents, currency = 'USD') => new Intl.NumberFormat(document.documentElement.lang || 'en-US', { style: 'currency', currency }).format(cents / 100);

  function showOverlay() {
    if (overlay) overlay.hidden = false;
    body.classList.add('no-scroll');
  }

  function closeAll() {
    mobileMenu?.classList.remove('open');
    mobileMenu?.setAttribute('aria-hidden', 'true');
    menuButton?.setAttribute('aria-expanded', 'false');
    cartDrawer?.classList.remove('open');
    cartDrawer?.setAttribute('aria-hidden', 'true');
    cartButton?.setAttribute('aria-expanded', 'false');
    if (overlay) overlay.hidden = true;
    body.classList.remove('no-scroll');
  }

  function openMenu() {
    closeAll();
    mobileMenu?.classList.add('open');
    mobileMenu?.setAttribute('aria-hidden', 'false');
    menuButton?.setAttribute('aria-expanded', 'true');
    showOverlay();
    mobileClose?.focus();
  }

  function openCart() {
    closeAll();
    cartDrawer?.classList.add('open');
    cartDrawer?.setAttribute('aria-hidden', 'false');
    cartButton?.setAttribute('aria-expanded', 'true');
    showOverlay();
    cartClose?.focus();
  }

  let toastTimer;
  function showToast(message) {
    if (!toast) return;
    toast.textContent = message;
    toast.classList.add('show');
    window.clearTimeout(toastTimer);
    toastTimer = window.setTimeout(() => toast.classList.remove('show'), 2800);
  }

  menuButton?.addEventListener('click', openMenu);
  mobileClose?.addEventListener('click', closeAll);
  cartButton?.addEventListener('click', () => { renderCart().finally(openCart); });
  cartClose?.addEventListener('click', closeAll);
  overlay?.addEventListener('click', closeAll);
  document.addEventListener('keydown', (event) => { if (event.key === 'Escape') closeAll(); });
  mobileMenu?.querySelectorAll('a').forEach((link) => link.addEventListener('click', closeAll));

  async function renderCart() {
    if (!window.TLO || !cartDrawer) return;
    const response = await fetch(`${window.TLO.cartUrl}.js`, { headers: { Accept: 'application/json' } });
    if (!response.ok) throw new Error('Unable to load bag.');
    const cart = await response.json();
    document.querySelectorAll('[data-cart-count]').forEach((node) => { node.textContent = cart.item_count; });
    const itemsNode = cartDrawer.querySelector('[data-cart-items]');
    const footerNode = cartDrawer.querySelector('[data-cart-footer]');
    if (!cart.items.length) {
      itemsNode.innerHTML = '<div class="empty-bag"><p>Your bag is waiting.</p><span>Begin with a composition that feels like you.</span></div>';
      footerNode.hidden = true;
      return;
    }
    itemsNode.innerHTML = cart.items.map((item) => `
      <article class="bag-item">
        <div class="bag-item-art">${item.image ? `<img src="${escapeHTML(item.image)}" alt="">` : `<img src="${escapeHTML(document.querySelector('.brand img')?.src || '')}" alt="">`}</div>
        <div><p>${escapeHTML(item.product_title)}</p><span>${escapeHTML(item.variant_title || '10 ML')} · Qty ${item.quantity}</span></div>
        <strong>${formatMoney(item.final_line_price, cart.currency)}</strong>
      </article>`).join('');
    footerNode.hidden = false;
    footerNode.querySelector('[data-cart-total]').textContent = formatMoney(cart.total_price, cart.currency);
  }

  document.addEventListener('submit', async (event) => {
    const form = event.target.closest('.js-product-form');
    if (!form) return;
    event.preventDefault();
    const submitButton = form.querySelector('[type="submit"]');
    if (submitButton?.disabled) return;
    submitButton?.setAttribute('aria-busy', 'true');
    try {
      const response = await fetch(window.TLO.cartAddUrl, { method: 'POST', body: new FormData(form), headers: { Accept: 'application/json' } });
      const result = await response.json();
      if (!response.ok) throw new Error(result.description || 'This composition could not be added.');
      await renderCart();
      showToast(`${result.product_title || 'Composition'} added to your ritual.`);
      openCart();
    } catch (error) {
      showToast(error.message);
    } finally {
      submitButton?.removeAttribute('aria-busy');
    }
  });

  document.querySelectorAll('[data-emotion-section]').forEach((section) => {
    const tabs = [...section.querySelectorAll('[data-emotion]')];
    const panels = [...section.querySelectorAll('[data-emotion-panel]')];
    tabs.forEach((tab) => tab.addEventListener('click', () => {
      tabs.forEach((item) => { const active = item === tab; item.classList.toggle('active', active); item.setAttribute('aria-selected', String(active)); });
      panels.forEach((panel) => { panel.hidden = panel.dataset.emotionPanel !== tab.dataset.emotion; });
    }));
  });

  document.querySelectorAll('[data-variant-select]').forEach((select) => {
    select.addEventListener('change', () => {
      const option = select.selectedOptions[0];
      const section = select.closest('[data-product-section]');
      section?.querySelectorAll('[data-button-price]').forEach((node) => { node.textContent = option.dataset.price; });
      const price = section?.querySelector('[data-product-price]');
      if (price) price.firstChild.textContent = `${option.dataset.price} `;
    });
  });

  document.querySelectorAll('[data-scent-quiz]').forEach((quiz) => {
    let step = 0;
    const answers = [];
    const stages = [...quiz.querySelectorAll('[data-step]')];
    const label = quiz.querySelector('[data-quiz-label]');
    const progress = quiz.querySelector('[data-quiz-progress]');
    const recommendationSets = {
      fresh: [['Golden Neroli', 'Luminous freshness and effortless clarity.'], ['White Veil', 'Clean elegance worn close to the skin.'], ['Azure Air', 'Mineral brightness with quiet energy.']],
      warm: [['Amber Hour', 'Golden warmth and a soft, enveloping trail.'], ['Velvet Santal', 'Polished woods with assured presence.'], ['Nocturne Musk', 'A deeper signature for after dark.']],
      bold: [['Nocturne Musk', 'Confident depth and nocturnal intrigue.'], ['Oud Atelier', 'A powerful, composed woody signature.'], ['Amber Hour', 'Warmth that rounds darker woods.']],
      intimate: [['White Veil', 'Clean softness and a private scent aura.'], ['Musk', 'Quiet warmth that becomes part of the skin.'], ['Desert Rose', 'A soft floral glow.']]
    };
    const showStep = () => {
      stages.forEach((stage) => { stage.hidden = Number(stage.dataset.step) !== step; });
      if (step < 4) { label.textContent = `0${step + 1} / 04`; progress.style.width = `${(step + 1) * 25}%`; return; }
      label.textContent = 'YOUR EDIT / COMPLETE'; progress.style.width = '100%';
      const key = answers.includes('bold') ? 'bold' : answers.includes('intimate') ? 'intimate' : answers.includes('fresh') ? 'fresh' : 'warm';
      quiz.querySelector('[data-recommendations]').innerHTML = recommendationSets[key].map(([name, text], index) => `<article class="recommendation"><span>0${index + 1} / YOUR EDIT</span><h3>${name}</h3><p>${text}</p></article>`).join('');
    };
    quiz.querySelectorAll('.quiz-options button').forEach((button) => button.addEventListener('click', () => { answers[step] = button.dataset.value; step += 1; showStep(); }));
    quiz.querySelector('.restart-quiz')?.addEventListener('click', () => { step = 0; answers.length = 0; showStep(); });
  });
})();
